import { render } from "./PackingSkuDialog.vue?vue&type=template&id=0f24835a"
import script from "./PackingSkuDialog.vue?vue&type=script&lang=js"
export * from "./PackingSkuDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__